<template>
  <div class="container">
    <div class="top-zimu" :class="{'top-zimu-text':type == 'text'}">
      <span :class="{'act':popupIndex == -1}" @click.stop="changeLetter(-1,'popupIndex')">全部</span>
      <span v-for="(item,index) in gameBarList" :key="index" :class="{'act':popupIndex == index}"
            @click.stop="changeLetter(index,'popupIndex')">{{ item.letter }}</span>
    </div>
    <template v-if="type == 'img'">
      <div class="items" v-if="popupIndex == -1">
        <div class="item" v-for="(item,index) in indexLists" :key="index" @click.stop="selectGame(item)">
          <img :src="getGameUrl(item.image)" class="item-img">
          <div class="item-text">{{ item.gameName }}</div>
        </div>
      </div>
      <div class="items" v-else>
        <div class="item" v-for="(item,index) in gameBarList[popupIndex]['gameDataList']" :key="index"
             @click.stop="selectGame(item)">
          <img :src="getGameUrl(item.image)" class="item-img">
          <div class="item-text">{{ item.gameName }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="inner" v-if="popupIndex == -1">
        <div class="game" v-for="(item,index) in indexLists" :key="index" @click.stop="selectGame(item)">
          {{ item.gameName }}
        </div>
      </div>
      <div class="inner" v-else>
        <div class="game" v-for="(item,index) in gameBarList[popupIndex]['gameDataList']" :key="index"
             @click.stop="selectGame(item)">{{ item.gameName }}
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import {common} from "@/composables/common";

const {getGameUrl} = common()
</script>
<script>
import pinyin from "js-pinyin";

export default {
  name: 'game-grid-letter',
  props: {
    //传入数据
    list: {
      type: Array,
      default: () => []
    },
    //已选择索引
    letterIndex: {
      type: Number,
      default: -1
    },
    //类型img图片和文字和text纯文字
    type: {
      type: String,
      default: 'img'
    }
  },
  data() {
    return {
      popupIndex: this.letterIndex,
      indexLists: [],
      gameBarList: []
    }
  },
  created() {
    this.init();
  },
  mounted() {

  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.indexLists = newVal
        this.init()
      },
      // immediate: true, // 组件初始化时立即执行一次
      deep: true,
    }
  },
  methods: {
    init() {
      // 添加26个字母
      const arr = [];
      for (let i = 65; i < 91; i++) {
        arr.push({
          letter: String.fromCharCode(i),
          gameDataList: []
        });
      }
      this.gameBarList = arr;
      if (this.indexLists.length > 0) {
        // 游戏数据进行排序
        this.indexLists.sort((a, b) => a.gameName.localeCompare(b.gameName));
        this.indexLists.forEach(game => {
          const pinyinString = pinyin.getFullChars(game.gameName)
          if (pinyinString.length > 0) {
            // 提取拼音的第一个字符并转换为大写字母
            const firstLetter = pinyinString.charAt(0).toUpperCase();
            // 计算字母在数据中的索引
            const index = firstLetter.charCodeAt(0) - 65;
            if (index >= 0 && index < this.gameBarList.length) {
              this.gameBarList[index].gameDataList.push(game);
            }
          }
        })
      }
    },
    //点击字母索引
    changeLetter(index, field) {
      if (index === -1) this.$emit('clickItem', {})
      if (this[field] != index) {
        this[field] = index
      }
    },
    //点击游戏
    selectGame(item) {
      this.$emit('clickItem', item)
    }
  }
}
</script>
<style scoped lang="scss">
.container {
  .top-zimu {
    background: #F5F8FF;
    border-radius: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 5px;
    margin-bottom: 15px;

    span {
      color: #767676;
      flex: 1;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      cursor: pointer;
      border-radius: 15px;

      &.act {
        background: #fff;
        color: #151515;
      }
    }
  }

  .top-zimu-text {
    span {
      font-size: 12px;
    }
  }

  .items {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    grid-gap: 20px 0;
    margin-top: 30px;

    .item {
      text-align: center;

      .item-img {
        width: 90px;
        height: 90px;
        border-radius: 10px;
        margin-bottom: 5px;
      }

      .item-text {
        color: #333333;
        font-size: 14px;
      }
    }
  }

  .inner {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin-top: 20px;

    .game {
      cursor: pointer;
      color: #7F8892;
      font-size: 14px;
      line-height: 28px;
      padding-left: 10px;
    }
  }
}
</style>
